
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'qualitytestIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'qualitytest',
				windowName: '仓库质检',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			addformShow() {
				let extra = {billCode:'CD202507140200',goodscode:'1010170041'}
				this.formModule = {
					name: this.moduleName,
					id: 0,
					controlltype: 1,
					windowName: '新建' + this.windowName,
					foreingKey: {},
					extra: extra
				}
				this.formwindowShow = true
			}
		},
		components: {
			
		}
	}
</script>
